export const PAGES_QUERY_KEY = "pages/";

export type PageKind =
  "events" | "partners" | "landing" | "blog" | "native" | "external";

export type Page = {
  id: number;
  path: string;
  title: string;
  kind: PageKind;
  contentUrl: string | null;
  menuSlug: string | null;
  showComments: boolean;
  showFooter: boolean;
  footerKind: string | null;
  footerText: string;
};
